import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    '& $content a': {
      color: TextColors.dark,
      '&:hover': {
        color: SecondaryColors.dark,
        '& svg': {
          color: SecondaryColors.dark,
        },
      },
    },
    '& $link': {
      '&:hover': {
        color: SecondaryColors.dark,
      },
      '&:not(:hover)': {
        color: TextColors.dark,
      },
      '& > .MuiTypography-h5': {
        // reference: https://stackoverflow.com/questions/5303263/fix-font-size-issue-on-mobile-safari-iphone-where-text-is-rendered-inconsisten
        '-webkit-text-size-adjust': '100%',
      },
    },
    '& $icon': {
      color: SecondaryColors.dark,
    },
    '& $date': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light1),
    },
  },
};

const darkTheme = {
  root: {
    '& $content a': {
      color: TextColors.light,
      '&:hover': {
        color: SecondaryColors.main,
        '& svg': {
          color: SecondaryColors.main,
        },
      },
    },
    '& $link': {
      '&:hover': {
        color: SecondaryColors.main,
      },
      '&:not(:hover)': {
        color: TextColors.light,
      },
      '& > .MuiTypography-h5': {
        // reference: https://stackoverflow.com/questions/5303263/fix-font-size-issue-on-mobile-safari-iphone-where-text-is-rendered-inconsisten
        '-webkit-text-size-adjust': '100%',
      },
    },
    '& $icon': {
      color: SecondaryColors.main,
    },
    '& $date': {
      color: hexToRGBA(TextColors.light, TextOpacities.dark1),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      position: 'relative',
      width: '100%',
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
    },
    content: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& a': {
        transition: 'all 150ms ease-in-out',
        textDecoration: 'none',
      },
    },
    link: {
      display: 'block',
      transition: 'color 150ms ease-in-out',
      whiteSpace: 'nowrap',
      width: 'fit-content',

      '& > *': {
        display: 'inline',
        verticalAlign: 'middle',
      },

      '&:not(:hover) .MuiSvgIcon-root': {
        opacity: '0',
        transform: 'translateX(-5px)',
      },

      '&:hover .MuiSvgIcon-root': {
        opacity: '1',
        transform: 'translateX(0px)',
      },
      '&.wrapSpace': {
        whiteSpace: 'normal',
      },
    },
    icon: {
      display: 'inline !important',
      fontSize: '1.25em !important',
      marginLeft: '5px !important',
      verticalAlign: 'middle',
      transition: 'all 150ms ease-in-out',
    },
    iconWrapper: {
      width: 0,
    },
    date: {
      '&.MuiTypography-root': {
        marginBottom: '12px',
      },
    },
  }),
  { name: 'GenPressCenterResourceMainContent' },
);

export default useStyles;
